import React from 'react';
import { useTranslation } from 'react-i18next';

const MenuBar = ({ pages }) => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';

  return (
    <div className="menu-bar-comp-container">
      <img
        className="img-responsive hidden-xs"
        src={`${
          isEnglish
            ? '/images/logo_en_2021_black.png'
            : '/images/logo_sk_2021_black.png'
        }`}
        alt="Portál FRI"
      />
    </div>
  );
};

MenuBar.propTypes = {};

export default MenuBar;
